<template>
  <div v-if="userHasAccess">
    <div id="edit-event" class="p-2 sm:p-4">
      <h1>Edit Event</h1>
      <div class='hr'></div>
      <template v-if="event.status !== 'ARCHIVED'">
        <tabs type="classic">
          <tab :selected='true' name="Overview" class="mt-4">
            <!--<h2>Overview</h2>-->
            <!--TODO: Break this form generator into separate component -->
            <form class="w-full max-w-2xl mt-4">
              <div v-for="s in overview_schema" :key="s.label" class="pb-2">
                <h3 class="mb-2 pb-1 border-b text-lg">{{s.label}}</h3>
                <div v-for="d in s.fields" :key="d.label" class='mb-3'>
                  <template v-if="d.type!='submit'">
                    <label class="block text-gray-900 text-sm font-bold mb-1" for="d.model">
                      {{d.label}}
                    </label>
                    <template v-if="d.type=='select'">
                      <div class="relative">
                        <select v-model="s.model[d.model]" class="block appearance-none w-full bg-gray-300 border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                          <option :value="null" selected disabled>
                            Please select a division
                          </option>
                          <option v-for="v in d.options"  :key="v.value" :value="v.value">
                            {{v.label}}
                          </option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        </div>
                      </div>
                    </template>
                    <template v-if="d.inputType==='date'">
                      <date-picker v-model="s.model[d.model]" value-type="YYYY-MM-DD" :format="Localized.getDateFormat(event.location_details.country)"></date-picker>
                    </template>
                    <input v-else-if="d.type=='input'" :type="d.inputType" v-model="s.model[d.model]" :placeholder="d.label" class="text-input focus:outline-none focus:shadow-outline">
                    <textarea v-else-if="d.type=='textArea'" v-model="s.model[d.model]" :placeholder="d.label" class="text-input" rows="3"/>
                    <input v-else-if="d.type=='checkbox'" v-model="s.model[d.model]" class="mr-2 leading-tight" type="checkbox">
                    <div v-if="d.hint" class="text-sm text-gray-600" v-html="linkify(d.hint)"></div>
                  </template>
                  <template v-else>
                    <button @click="d.onSubmit" class="btn btn-blue" type="button">
                      {{d.buttonText}}
                    </button>
                  </template>
                </div>
              </div>
            </form>
          </tab>
          <tab name="Settings" class="mt-4">
            <form class="w-full max-w-2xl mt-4">
              <div v-for="s in settings_schema" :key="s.label" class="pb-2">
                <h3 class="mb-2 pb-1 border-b text-lg">{{s.label}}</h3>
                <div v-for="d in s.fields" :key="d.label" class='mb-3'>
                  <template v-if="d.type!='submit' && !d.hide">
                    <label class="block text-gray-900 text-sm font-bold mb-1" for="d.model">
                      {{d.label}}
                    </label>
                    <template v-if="d.type=='select'">
                      <div class="relative">
                        <select v-model="s.model[d.model]" class="block appearance-none w-full bg-gray-300 border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                          <option :value="null" selected disabled>
                            Please select a division
                          </option>
                          <option v-for="v in d.options"  :key="v.value" :value="v.value">
                            {{v.label}}
                          </option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        </div>
                      </div>
                    </template>
                    <template v-if="d.inputType==='date'">
                      <date-picker v-model="s.model[d.model]" value-type="YYYY-MM-DD" :format="Localized.getDateFormat(event.location_details.country)"></date-picker>
                    </template>
                    <input v-else-if="d.type=='input'" :type="d.inputType" v-model="s.model[d.model]" :placeholder="d.placeholder ? d.placeholder : d.label" class="text-input focus:outline-none focus:shadow-outline">
                    <textarea v-else-if="d.type=='textArea'" v-model="s.model[d.model]" :placeholder="d.label" class="text-input"  rows="3"/>
                    <input v-else-if="d.type=='checkbox'" v-model="s.model[d.model]" class="mr-2 leading-tight" type="checkbox">
                    <div v-if="d.hint" class="text-sm text-gray-600" v-html="linkify(d.hint)"></div>
                  </template>
                  <template v-else-if="!d.hide">
                    <button @click="d.onSubmit" class="btn btn-blue" type="button">
                      {{d.buttonText}}
                    </button>
                  </template>
                </div>
              </div>
            </form>
          </tab>

          <tab name="Entry Questions" class="mt-4">
            <edit-entry-questions :allEntryQuestions="event.entry_questions"/>
          </tab>

          <tab name="Files & Links">
            <ManageFiles :event="event"/>
          </tab>

          <tab name="Special Pricing" class="mt-4">
            <SpecialPricing/>
          </tab>
          <tab name="User Access" class="mt-4" v-if="currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2' || currentUser.user_id === this.adminData.admin_id || currentUser.role === 'ADMIN'">
            <AdminAccess/>
          </tab>
          <tab name="Super User" v-if="currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2'" class="mt-4">
            <div class="flex justify-between items-center">
              <form class="w-full mt-4">
                <div v-for="s in super_schema" :key="s.label" class="pb-2">
                  <h3 class="mb-2 pb-1 border-b text-lg">{{s.label}}</h3>
                  <div v-for="d in s.fields" :key="d.label" class='mb-3'>
                    <template v-if="d.type!='submit'">
                      <label class="block text-gray-900 text-sm font-bold mb-2" for="d.model">
                        {{d.label}}
                      </label>
                      <template v-if="d.type=='select'">
                        <div class="relative">
                          <select v-model="s.model[d.model]" class="block appearance-none w-full bg-gray-300 border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                            <option :value="null" selected disabled>
                              Please select an option below
                            </option>
                            <option v-for="v in d.options"  :key="v.value" :value="v.value">
                              {{v.label}}
                            </option>
                          </select>
                          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="d.type==='input'">
                        <template v-if="d.inputType==='date'">
                          <date-picker v-model="s.model[d.model]" value-type="YYYY-MM-DD" :format="Localized.getDateFormat(event.location_details.country)"></date-picker>
                        </template>
                        <input v-else-if="d.inputType !=='number'"  :type="d.inputType" v-model="s.model[d.model]" :placeholder="d.inputType === 'date' ? 'yyyy-mm-dd' : d.label" class="text-input focus:outline-none focus:shadow-outline">
                        <input v-else  :type="d.inputType" v-model.number="s.model[d.model]" :placeholder="d.label" class="text-input focus:outline-none focus:shadow-outline">
                      </template>
                      <textarea v-else-if="d.type=='textArea'" v-model="s.model[d.model]" :placeholder="d.label" class="text-input" rows="3"/>
                      <input v-else-if="d.type=='checkbox'" v-model="s.model[d.model]" class="mr-2 leading-tight" type="checkbox">
                      <template v-else-if="d.type=='json'">
                        <v-jsoneditor v-model="s.model[d.model]" :options="{mode:'code'}" :plus="false" height="300px" class="mb-4"/>
                      </template>
                      <div v-if="d.hint" class="text-sm text-gray-600" v-html="linkify(d.hint)"></div>
                    </template>
                    <template v-else>
                      <button @click="d.onSubmit" class="btn btn-blue" type="button">
                        {{d.buttonText}}
                      </button>
                    </template>
                  </div>
                </div>
              </form>
            </div>
          </tab>

        </tabs>
      </template>
      <div v-else class="text-center">
        <h2 class="text-4xl mb-2">This show is Archived.</h2>
        <p class="text-2xl mt-8">Looking for your show data?</p>
        <p class="text-lg mt-2"> Don't worry, you can still acess all your exhibitor and entry data. Just click onto another section of the Admin Dashboard to view the archived data.</p>
        <p class="text-2xl mt-8">Need to set up a new show?</p>
        <a v-if="adminData.show_specialist" class="link" :href="`/shows#/new-show-signup?show_specialist_id=${adminData.show_specialist.specialist_id}`">Click here to setup a new show.</a>
        <a v-else class="link" :href="`/shows#/new-show-signup`">Click here to setup a new show.</a>

      </div>
    </div>
  </div>
  <div v-else>
    <NoAccess :section="'Event'" :admin_email="adminData.show_admin.email"/>
  </div>
</template>

<script>

import EditEntryQuestions from '@/components/admin/EditEntryQuestions_new.vue'
import ManageFiles from '@/components/admin/ManageFiles.vue'
import SpecialPricing from '@/components/admin/SpecialPricing.vue'
import AdminAccess from '@/components/admin/AdminAccess.vue'
import NoAccess from '@/views/admin/NoAccess.vue'
// import EventShows from '@/components/admin/EventShows.vue'
// import ManageShowTypes from '@/components/admin/ManageShowTypes.vue'
import VJsoneditor from 'v-jsoneditor'

export default {
  name: 'edit-event',
  components: {
    // ShowmanTypeAhead,
    // draggable,
    EditEntryQuestions,
    ManageFiles,
    // EventShows
    // ManageShowTypes
    VJsoneditor,
    SpecialPricing,
    AdminAccess,
    NoAccess
  },
  data () {
    return {
    }
  },
  methods: {
    updateEvent (updateType) {
      let eventUpdateData = {
        event_id: this.event.event_id
      }
      if (updateType === 'overview') {
        eventUpdateData.name = this.event.name
        eventUpdateData.start_date = this.event.start_date
        eventUpdateData.end_date = this.event.end_date
        eventUpdateData.event_details = this.event.event_details
        if (eventUpdateData.event_details.website) {
          eventUpdateData.event_details.website = this.formatWebsite(eventUpdateData.event_details.website)
        }
        if (eventUpdateData.event_details.host_hotel_website) {
          eventUpdateData.event_details.host_hotel_website = this.formatWebsite(eventUpdateData.event_details.host_hotel_website)
        }
        eventUpdateData.location_details = this.event.location_details
      } else if (updateType === 'settings') {
        eventUpdateData.entry_settings = this.event.entry_settings

        // Check if CC Settings need updated.
        this.$store.state.apiInstance.post(`/callFunction/updateEventSettings`, {
          updateData: JSON.stringify({
            event_id: this.event.event_id,
            field: 'exhibitors_pay_credit_fee',
            value: this.event.event_settings.exhibitors_pay_credit_fee,
            type: 'boolean'
          })
        })
          .catch(() => {
            alert('Error Updating CC Settings')
          })
        // Check if BTRJLA Setting needs to be updated
        this.$store.state.apiInstance.post(`/callFunction/updateEventSettings`, {
          updateData: JSON.stringify({
            event_id: this.event.event_id,
            field: 'btrjla_sanctioned',
            value: this.event.event_settings.btrjla_sanctioned,
            type: 'boolean'
          })
        })
          .catch(() => {
            alert('Error Updating CC Settings')
          })
        // Check if Entry Number Settings Need to be updated
        if (this.event.event_settings.backtag_type === 'entry_numbers') {
          if (!this.event.event_settings.entry_numbers) {
            this.$store.dispatch('setEventSettings_admin', {
              event_id: this.event.event_id,
              field: 'entry_numbers',
              value: {},
              type: 'json'
            })
              .then(() => {
                /* if (this.event.status === 'PUBLISHED') {
                  this.notie.force({
                    type: 3,
                    text: `If you already have entries submitted be sure to visit the "Entries" Section of your dashboard to review settings and trigger previous entries to be numbered.`
                  })
                } */
                this.$store.state.apiInstance.post(`/renumberEntryNumbers`, {event_id: this.event.event_id, forceAllow: true})
                  .catch(() => {
                    alert('Error Assigning Entry Numbers')
                  })
              })
              .catch(() => {
                alert('Error Updating Back Tag Settings')
              })
          }
        } else {
          if (this.event.event_settings.entry_numbers) {
            this.$store.dispatch('setEventSettings_admin', {
              event_id: this.event.event_id,
              field: 'entry_numbers',
              value: null,
              type: 'json'
            })
              .catch(() => {
                alert('Error Updating Back Tag Settings')
              })
              .then(() => {
                this.$store.state.apiInstance.post(`/removeEntryNumbers`, {event_id: this.event.event_id})
                  .catch(() => {
                    alert('Error Removing Entry Numbers')
                  })
              })
          }
        }
      } else if (updateType === 'admin') {
        eventUpdateData.status = this.event.status
        eventUpdateData.event_settings = this.event.event_settings
        eventUpdateData.files = this.event.files
        eventUpdateData.sponsor_settings = this.event.sponsor_settings
        // Figure out how to handle Entry Settings...
        this.$store.state.apiInstance.post(`/callFunction/updateEventEntrySettings`, {
          updateData: JSON.stringify({
            event_id: this.event.event_id,
            field: 'use_exhibitor_declared_weights',
            value: this.event.entry_settings.use_exhibitor_declared_weights,
            type: 'boolean'
          })
        })
          .catch(() => {
            alert('Error Updating Declared Weight Settings')
          })

        this.$store.state.apiInstance.post(`/callFunction/updateEventEntrySettings`, {
          updateData: JSON.stringify({
            event_id: this.event.event_id,
            field: 'no_online_payments',
            value: this.event.entry_settings.no_online_payments,
            type: 'boolean'
          })
        })
          .catch(() => {
            alert('Error Updating no_online_payments')
          })
        // Figure out how to handle Event Details.
        this.$store.state.apiInstance.post(`/callFunction/updateEventDetail`, {
          updateData: JSON.stringify({
            event_id: this.event.event_id,
            field: 'enter_show_text',
            value: this.event.event_details.enter_show_text,
            type: 'text'
          })
        })
          .catch(() => {
            alert('Error Updating enter_show_text')
          })

        this.$store.state.apiInstance.post(`/callFunction/updateEventDetail`, {
          updateData: JSON.stringify({
            event_id: this.event.event_id,
            field: 'home_cover_url',
            value: this.event.event_details.home_cover_url,
            type: 'text'
          })
        })
          .catch(() => {
            alert('Error Updating home_cover_url')
          })

        this.$store.state.apiInstance.post(`/callFunction/updateEventDetail`, {
          updateData: JSON.stringify({
            event_id: this.event.event_id,
            field: 'event_card_cover_url',
            value: this.event.event_details.event_card_cover_url,
            type: 'text'
          })
        })
          .catch(() => {
            alert('Error Updating event_card_cover_url')
          })
      }
      this.$store.dispatch('updateEvent', eventUpdateData)
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Event, ${this.event.name} Successfully Updated`
          })
        })
        .catch(() => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error updating event, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    formatWebsite (website) {
      if (website) {
        let webRe = /^https?:\/\/(.*)/i
        var hasHttp = website.match(webRe)
        if (hasHttp) {
          return website
        } else {
          return 'https://' + website
        }
      }
      return ''
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.user
    },
    userHasAccess () {
      let access = false
      let foundUser = false
      if (this.adminData.admin_id === this.currentUser.user_id || this.currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2') {
        access = true
      } else {
        this.adminData.event_user_access.forEach(ur => {
          if (ur.user_id === this.currentUser.user_id) {
            foundUser = true
            access = ur.event_access
          }
        })
      }
      // If still no code set check if included in admin_id then assume it is a show series specialist and set to FULL for now.
      if (!foundUser) {
        if (this.adminData.admin_ids.includes(this.currentUser.user_id)) {
          access = true
        } else if (this.currentUser.role === 'ADMIN') {
          access = true
        }
      }
      return access
    },
    adminData () {
      return this.$store.state.admin.adminData
    },
    event () {
      return this.$store.state.admin.adminData.event
    },
    shows () {
      return this.event.shows
    },
    overview_schema () {
      return [
        {
          label: 'Basic',
          model: this.event,
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Name of Show',
              model: 'name',
              id: 'user_name',
              placeholder: 'Show name',
              required: true
            },
            {
              type: 'input',
              inputType: 'date',
              label: 'Date of First Show',
              model: 'start_date',
              required: true,
              format: 'YYYY-MM-DD'
            },
            {
              type: 'input',
              inputType: 'date',
              label: 'Date of Last Show',
              model: 'end_date',
              required: true,
              format: 'YYYY-MM-DD'
            }
          ]
        },
        {
          label: 'Event Details',
          model: this.event.event_details,
          fields: [
            {
              type: 'textArea',
              label: 'Contact Information',
              model: 'contact_info',
              placeholder: 'Contact_info',
              rows: 3
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Show Website or Facebook Page',
              model: 'website',
              hint: 'Where can exhibitors find out additional information about your show? Please include the full url to the website: (https://www.yourwebsite.com)',
              placeholder: 'website',
              required: true
            },
            {
              type: 'textArea',
              label: 'Arrival Information',
              model: 'arrival_info'
            },
            {
              type: 'textArea',
              label: 'Check In Times',
              model: 'check_in_times',
              placeholder: 'Check In Time',
              rows: 3
            },
            {
              type: 'textArea',
              label: 'Health Checks',
              model: 'health_check',
              placeholder: 'Health info',
              rows: 3
            },
            {
              type: 'textArea',
              label: 'Refund Policy',
              model: 'refund_policy',
              placeholder: 'Put details on refund policy here.',
              rows: 3
            },
            {
              type: 'textArea',
              label: 'Lodging Information',
              model: 'lodging_info',
              placeholder: 'Lodging Information',
              rows: 3
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Host Hotel website',
              model: 'host_hotel_website',
              placeholder: 'host hotel website',
              required: true,
              hint: 'Please include the full url to the website: (https://www.yourwebsite.com)'
            },
            {
              type: 'textArea',
              label: 'Other show information',
              model: 'other_info',
              placeholder: 'Other info',
              rows: 3
            }
          ]
        },
        {
          label: 'Location',
          model: this.event.location_details,
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Show Location',
              model: 'location_name',
              placeholder: 'Location',
              required: true
            },
            {
              type: 'select',
              label: 'Country',
              model: 'country',
              placeholder: 'Country',
              options: this.Localized.countryList.map(({name, abbreviation}) => ({label: name, value: abbreviation})),
              required: true
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Address',
              model: 'address',
              placeholder: 'Address',
              required: true
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'City',
              model: 'city',
              placeholder: 'City',
              required: true
            },
            {
              type: 'select',
              label: 'State/Province',
              model: 'state',
              placeholder: 'State',
              options: this.Localized.getStateList(this.event.location_details.country).map(({name, abbreviation}) => ({label: name, value: abbreviation})),
              required: true
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Zip',
              model: 'zip',
              placeholder: 'Zip',
              required: true
            },
            {
              type: 'submit',
              buttonText: 'Update Event',
              onSubmit: () => {
                this.updateEvent('overview')
              },
              validateBeforeSubmit: true
            }
          ]
        }
      ]
    },
    settings_schema () {
      return [
        {
          label: 'Event Settings',
          model: this.event.event_settings,
          fields: [
            {
              type: 'checkbox',
              label: 'Do you want to charge credit card fees to exhibitors?',
              model: 'exhibitors_pay_credit_fee',
              hint: `Credit card fees are ${this.event.event_settings.credit_card_percent_fee ? `${(this.event.event_settings.credit_card_percent_fee * 100).toFixed(2)}%` : '2.90%'} + ${this.event.event_settings.credit_card_fixed_fee || this.event.event_settings.credit_card_fixed_fee === 0 ? `$${(this.event.event_settings.credit_card_fixed_fee * 1).toFixed(2)}` : '30¢'}. If not paid by exhibitor the fee will be taken out of the total amount deposited in your bank account.`
            },
            {
              type: 'checkbox',
              label: 'Is your show BTRJLA Sanctioned?',
              model: 'btrjla_sanctioned',
              hint: `Click here to sanction your show today: https://btrjla.com/product/sanctioning-fee/`
            }
          ]
        },
        {
          label: 'Entry Settings',
          model: this.event.entry_settings,
          fields: [
            {
              type: 'input',
              inputType: 'date',
              label: 'Online Entries open on',
              hint: 'What day do you want to start accepting Online Entries?',
              model: 'start_online_entries',
              require: true,
              format: 'YYYY-MM-DD'
            },
            {
              type: 'select',
              label: 'How many pricing tiers do you have?',
              model: 'pricing_tiers',
              options: [
                {
                  label: 1,
                  value: 1
                },
                {
                  label: 2,
                  value: 2
                },
                {
                  label: 3,
                  value: 3
                }
              ]
            },
            {
              type: 'input',
              hide: this.event.entry_settings.pricing_tiers < 3,
              inputType: 'date',
              label: 'After Which date will the EARLY pricing end?',
              hint: 'What is the last day an exhibitor can enter to receive the early bird pricing discount?',
              model: 'early_bird_date',
              required: true,
              format: 'YYYY-MM-DD'
            },
            {
              type: 'input',
              hide: this.event.entry_settings.pricing_tiers < 2,
              inputType: 'date',
              label: 'After which date will the LATE Pricing Start?',
              hint: 'What is the last day an exhibitor can enter to receive the standard pricing before late fees take effect?',
              model: 'late_fee_date',
              required: true,
              format: 'YYYY-MM-DD'
            },
            {
              type: 'input',
              inputType: 'date',
              label: 'What is the last day to submit online entries?',
              hint: 'We recommend leaving online open until your last show day if you are able to.',
              model: 'last_day_of_online_entries',
              required: true,
              format: 'YYYY-MM-DD'
            },
            {
              type: 'checkbox',
              label: 'Allow Exhibitors to add additional entries at their original entry rate',
              hint: 'If this box is checked exhibitors can continue to add extra entry at the original rate they entered at. Meaning if they submitted their entries before the late fee deadline they can add extra entries at the show at this same rate.',
              model: 'additions_at_early_rate'
            },
            {
              type: 'checkbox',
              label: 'Show will accept entries the day of show?',
              model: 'day_of_show_entries',
              hint: 'You will still be able to add in entries from the admin side if this box isn\'t checked.'
            }

          ]
        },
        {
          label: 'Backtag Type',
          model: this.event.event_settings,
          fields: [
            {
              type: 'select',
              label: 'What type of Backtags would you like to use?',
              model: 'backtag_type',
              options: [
                {
                  label: 'Exhibitor Numbers',
                  value: 'exhibitor_numbers'
                },
                {
                  label: 'Entry Numbers',
                  value: 'entry_numbers'
                }
              ],
              hint: `By default every exhibitor is assigned a number, or you can choose to assign a number for each individual entry. Backtag number will be printed in the showbooks, but can be ignored if you won't be using them at your show.`
            }
          ]
        },
        {
          label: 'Member Pricing',
          model: this.event.entry_settings,
          fields: [
            {
              type: 'checkbox',
              label: 'Show has member pricing?',
              model: 'has_member_pricing',
              hint: 'Use this option only if you are offering discount pricing for members of a club or organization.'
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'What is the Membership called? (e.g. KGPA Member)',
              model: 'member_pricing_label',
              required: true
            },
            {
              type: 'submit',
              buttonText: 'Update Event',
              onSubmit: () => {
                this.updateEvent('settings')
              },
              validateBeforeSubmit: true
            }
          ]
        }
        /* {
          label: 'Age Settings',
          model: this.event.entry_settings,
          fields: [
            {
              type: 'input',
              inputType: 'date',
              label: 'Breeding Classes: What "BASE DATE" do you want to use?',
              hint: 'This is only used when calculating age as of ranges for your classes, i.e. 3-6 Months.',
              model: 'breeding_age_date',
              required: true,
              format: 'YYYY-MM-DD'
            },
            {
              type: 'input',
              inputType: 'date',
              label: 'Showmanship Classes: What "Age as of Date" do you want to use?',
              model: 'showmanship_age_date',
              required: true,
              format: 'YYYY-MM-DD'
            },
            {
              type: 'submit',
              buttonText: 'Update Event',
              onSubmit: () => {
                this.updateEvent('settings')
              },
              validateBeforeSubmit: true
            }
          ]
        } */
      ]
    },
    super_schema () {
      return [
        {
          label: 'Event Status',
          model: this.event,
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Event Status',
              model: 'status'
            }
          ]
        },
        {
          label: 'Event Details',
          model: this.event.event_details,
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Event Card Cover Url',
              model: 'event_card_cover_url'
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Home Cover Url',
              model: 'home_cover_url'
            },
            {
              type: 'textArea',
              label: 'Enter Show Text',
              model: 'enter_show_text'
            }
          ]
        },
        {
          label: 'Event Settings',
          model: this.event.event_settings,
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Timezone',
              model: 'time_zone',
              required: true
            },
            {
              type: 'input',
              inputType: 'number',
              label: 'Credit Card Fixed Fee',
              model: 'credit_card_fixed_fee',
              required: true
            },
            {
              type: 'input',
              inputType: 'number',
              label: 'Credit Card Percent Fee',
              model: 'credit_card_percent_fee',
              required: true
            },
            {
              type: 'input',
              inputType: 'number',
              label: 'Add On Fees',
              model: 'add_on_fees',
              required: false
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Add On Notes',
              model: 'add_on_notes',
              required: false
            },
            {
              type: 'checkbox',
              label: 'Allow Enter & Pay at Show',
              model: 'allow_pay_at_show'
            },
            {
              type: 'checkbox',
              label: 'Diasble deleting entries after entering.',
              model: 'disable_delete_after_enter'
            },
            {
              type: 'checkbox',
              label: 'Publish Show Books',
              model: 'publish_show_book'
            },
            {
              type: 'checkbox',
              label: 'Publish Results',
              model: 'publish_results'
            },
            {
              type: 'input',
              inputType: 'tet',
              label: 'Financial Tab Password',
              model: 'financial_tab_password',
              required: true
            },
            {
              type: 'checkbox',
              label: 'Dynamic Class Lists',
              model: 'dynamic_class_lists'
            },
            {
              type: 'checkbox',
              label: 'Enable Class Ring Modifier ',
              model: 'class_ring_modifier'
            },
            {
              type: 'checkbox',
              label: 'Has Premium Payouts',
              model: 'has_premium_payouts'
            },
            {
              type: 'checkbox',
              label: 'Has Auction',
              model: 'has_auction'
            },
            {
              type: 'json',
              label: 'Premier Exhibitor Rules',
              model: 'premier_exhibitor_rules'
            }
          ]
        },
        {
          label: 'Entry Settings',
          model: this.event.entry_settings,
          fields: [
            {
              type: 'checkbox',
              label: 'Declared Weights',
              model: 'use_exhibitor_declared_weights'
            },
            {
              type: 'checkbox',
              label: 'Don\'t allow online payments',
              model: 'no_online_payments'
            }
          ]
        },
        {
          label: 'Files',
          model: this.event,
          fields: [
            {
              type: 'json',
              label: 'Files',
              model: 'files'
            }
          ]
        },
        {
          label: 'Sponsor Settings',
          model: this.event,
          fields: [
            {
              type: 'json',
              label: 'Sponsor Settings',
              model: 'sponsor_settings'
            },
            {
              type: 'submit',
              buttonText: 'Update Event',
              onSubmit: () => {
                this.updateEvent('admin')
              },
              validateBeforeSubmit: true
            }
          ]
        }
      ]
    }
  },
  mounted () {
    if (!this.event.event_settings.entry_numbers) {
      this.event.event_settings.backtag_type = 'exhibitor_numbers'
    } else {
      this.event.event_settings.backtag_type = 'entry_numbers'
    }
  }
}
</script>

<style>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.draggable:hover {
    cursor: grab;
}
</style>
